"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xhv = exports.decodeXhvAddress = exports.encodeXhvAddress = void 0;
const xmr_js_1 = require("./xmr.js");
const name = "xhv";
const coinType = 535;
exports.encodeXhvAddress = xmr_js_1.encodeXmrAddress;
exports.decodeXhvAddress = xmr_js_1.decodeXmrAddress;
exports.xhv = {
    name,
    coinType,
    encode: exports.encodeXhvAddress,
    decode: exports.decodeXhvAddress,
};
//# sourceMappingURL=xhv.js.map